class ZCSupportHub extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-help-search]');
    this.items = [...this.querySelectorAll('[data-help-item]')];
    this.empty = this.querySelector('[data-help-empty]');
    this.topic = 'delivery';

    this.querySelector('[data-help-form]')?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.filter(true);
    });

    this.input?.addEventListener('search', () => {
      this.filter(false);
    });

    this.querySelectorAll('[data-help-topic]').forEach((button) => {
      button.addEventListener('click', () => {
        this.topic = button.dataset.helpTopic;
        this.input.value = '';

        this.querySelectorAll('[data-help-topic]').forEach((item) => {
          item.setAttribute(
            'aria-pressed',
            String(item === button)
          );
        });

        this.filter(false);
      });
    });

    /* 页面第一次打开时立即显示默认分类 */
    this.filter(false);
  }

  filter(scroll) {
    const words = (this.input?.value || '')
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    let visible = 0;

    this.items.forEach((item) => {
      const text = `${item.textContent} ${item.dataset.keywords || ''}`.toLowerCase();

      const match = words.length
        ? words.every((word) => text.includes(word))
        : item.dataset.topic === this.topic;

      item.hidden = !match;
      item.open = false;

      if (match) visible += 1;
    });

    this.empty?.classList.toggle('is-visible', visible === 0);

    if (scroll) {
      this.querySelector('#zc-common-help')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
}

if (!customElements.get('zc-support-hub')) {
  customElements.define('zc-support-hub', ZCSupportHub);
}